import { createGlobalStore } from 'hox';
import { trpc } from '@bitbot/api';
import { useRouter } from 'next/router';
import { useToken } from '../user/token';
import { useState } from 'react';
import { toastError } from '@bitbot/ui-design';
import { debounce } from 'lodash';
import dayjs from 'dayjs';

interface IStakeRes {
  amount: number;
  expireDate: string;
  currentTime: string;
  poolName: string;
}

export const [useStake] = createGlobalStore(() => {
  const { hasLogin } = useToken();
  const [currentPool, setCurrentPool] = useState(0);
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [res, setRes] = useState<IStakeRes>();

  const router = useRouter();

  const { data: stakingStatus, refetch: refetchAllStakingStatus } =
    trpc.staking.getAllStakingStatus.useQuery(undefined, {
      enabled: hasLogin,
    });
  // const stakeMutation = trpc.staking.stakeAmountInPool.useMutation({
  //   onSuccess: () => {
  //     refetchAllStakingStatus();
  //     router.replace('/stake/stake-success');
  //     setTimeout(() => {
  //       setAmount('');
  //     }, 1000);
  //   },
  // });

  // const stake = debounce(async () => {
  //   if (isLoading) return;
  //   setIsLoading(true);
  //   try {
  //     const res = await stakeMutation.mutateAsync({
  //       amount: +amount,
  //       poolName: pools[currentPool].name,
  //     });
  //     setRes({
  //       poolName: pools[currentPool].name,
  //       amount: res.amount,
  //       expireDate: dayjs(pools[currentPool].endDate).format('YYYY-MM-DD'),
  //       currentTime: dayjs(Date.now()).format('h:mm A'),
  //     });
  //     setTimeout(() => {
  //       setIsLoading(false);
  //     }, 1000);
  //   } catch (error: any) {
  //     toastError(error.message);
  //     setIsLoading(false);
  //   }
  // }, 200);

  return {
    stakingStatus,
    currentPool,
    setCurrentPool,
    stake: () => {},
    amount,
    setAmount,
    isLoading,
    res,
  };
});
